import React from "react";
import BaseLayout from "../../../components/BaseLayout/BaseLayout";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Typography,
  withStyles,
  withWidth,
} from "@material-ui/core";
import InputImage from "../../../components/InputImage";
import { useState } from "react";

const form2 = () => {
  // const [formVoucher, setformVoucher] = useState({
  //   voucherType: "",
  //   voucherName: "",
  //   voucherValue: "",
  //   voucherValueType: "",
  //   description: "",
  //   term: "",
  //   startDate: "",
  //   endDate: "",
  //   picture: "",
  // });
  return (
    <>
      <BaseLayout background="gray">
        <div className="row">
          <div className="col-12">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb bg-none">
                <li className="breadcrumb-item">
                  <a href="/voucherMall">Voucher</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Add Voucher
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-12">
            <div className="card border-0 rounded-8px">
              <div className="card-header bg-white">
                <h3 className="card-title mb-0 font-20">Add Voucher</h3>
              </div>

              <div class="container">
                <form>
                  <div class="form-group">
                    <label for="voucherType" class="col-form-label">
                      Voucher Type
                    </label>
                    <select class="form-control" id="voucherType">
                      <option>Voucher Mall</option>
                      <option>Voucher Tenant</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label for="voucherName" class="col-form-label">
                      Voucher Name
                    </label>
                    <input type="text" class="form-control" id="voucherName" />
                  </div>
                  <div class="form-group row">
                    <div class="col-6">
                      <label for="voucherValue" class="col-form-label">
                        Voucher Value
                      </label>
                      <div class="input-group mb-3">
                        <div class="input-group-prepend">
                          <span class="input-group-text">Rp</span>
                        </div>
                        <input type="text" class="form-control" />
                      </div>
                    </div>
                    <div class="col-6 ">
                      <label for="voucherValueType" class="col-form-label">
                        Voucher Value Type
                      </label>
                      <br />
                      <div
                        class="btn-group"
                        role="group"
                        aria-label="Basic example"
                      >
                        <button
                          type="button"
                          class="btn btn-secondary"
                          disabled
                        >
                          %
                        </button>

                        <button type="button" class="btn btn-secondary">
                          Amount
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="description" class="col-form-label">
                      Description
                    </label>
                    <textarea
                      class="form-control"
                      id="description"
                      rows="3"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <label for="termAndCondition" class="col-form-label">
                      Term and Condition
                    </label>
                    <textarea
                      class="form-control"
                      id="termAndCondition"
                      rows="3"
                    ></textarea>
                  </div>
                  <div class="form-group row">
                    <div class="col-6">
                      <label for="startDate" class="col-form-label">
                        Start Date
                      </label>
                      <input type="date" class="form-control" id="startDate" />
                    </div>
                    <div class="col-6">
                      <label for="endDate" class="col-form-label">
                        End Date
                      </label>
                      <input type="date" class="form-control" id="endDate" />
                    </div>
                  </div>
                  <Paper
                    // className={classes.root}
                    style={{
                      boxShadow: "none",
                      padding: "16px 24px",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      style={{ fontWeight: "bolder", fontSize: 18 }}
                      gutterBottom
                    >
                      Graphic
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={3} md={3} lg={3}>
                        <Typography
                          variant="subtitle2"
                          style={{ fontSize: 13, fontWeight: "bolder" }}
                        >
                          Voucher Picture
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={9} md={9} lg={9}>
                        <InputImage
                          // image={state.formData.image_urls[0] || ""}
                          maxSize={1000}
                          aspectW={16}
                          aspectH={9}
                          removeType="reset"
                          onUploadDone={(url) => {
                            // const { formData } = state;
                            // formData.image_urls.push(url);
                            // setState({ formData });
                          }}
                          onRemove={(url) => {
                            // const { formData } = state;
                            // formData.image_urls = [];
                            // setState({ formData });
                          }}
                          style={{
                            marginTop: "0px !important",
                            width: "100%",
                            height: 240,
                            maxWidth: "100%",
                            maxHeight: 240,
                          }}
                          styleWrapper={{
                            borderColor: "#BDBDBD",
                            borderRadius: 0,
                          }}
                          styleImage={{ height: "auto", width: "100%" }}
                        />
                        <p
                          style={{
                            fontSize: 10,
                            color: "#757575",
                            lineHeight: 1,
                          }}
                        >
                          JPEG or 32-bit PNG
                          <br />
                          1280 px by 720 px
                          <br />
                          16:9
                          <br />
                          Up to 1 MB
                        </p>
                      </Grid>
                    </Grid>
                  </Paper>

                  <button type="submit" class="btn btn-primary">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* <h1>ihzaaaaa</h1> */}
      </BaseLayout>
    </>
  );
};

export default form2;
